import { Container, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined';
import card from '../../../assest/img/card.png';
import payment from '../../../assest/img/Credit-card.png';
import currency from '../../../assest/img/Frame.png';
import time from '../../../assest/img/Time-Square.png';
import verified from '../../../assest/img/verified.png';
import './style.scss';

Hero.propTypes = {};

function Hero(props) {
    const { t } = useTranslation();

    return (
        <div className="hero-section">
            <Container maxWidth="xl">
                <Grid
                    container
                    spacing={2}
                    sx={{
                        alignItems: 'center',
                        '@media screen and (max-width: 600px)': {
                            flexDirection: 'column-reverse',
                        },
                    }}
                >
                    <Grid item xs={12} sm={6}>
                        <div className="hero-text">
                            <h1>{t('hero_title1')}</h1>
                            <p>{t('hero_title2')}</p>
                            <p>{t('hero_value1')}</p>
                            <p>{t('hero_value2')}</p>
                            <div>
                                <a
                                    style={{ fontWeight: 700 }}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href="https://www.saisoncard.co.jp/lineup/select/digital.php?cd=14V1&sd=207&fbclid=IwAR3gt_RsvkfWzxrloVMI5IB17NyQgKJgzeITxEgFu6lx0E5fa5i0ymdIGUc"
                                    className="btn"
                                >
                                    {t('button')}
                                </a>
                            </div>
                            {/* old design */}
                            {/* <span>
                                {t('hero.title2')}{' '}
                                <strong>{t('hero.title3')}</strong>
                            </span> */}
                            <div>
                                <a
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href="https://faq.saisoncard.co.jp/saison/search?site=OA5LHO14&charset=UTF-8&query=SAISON+CARD+Digital&_gl=1*mechbr*_ga*MTk1MzQyNjg0LjE2NTQ1NjkwODM.*_ga_BKKP87CX6T*MTY1NTE3OTkxNi45LjEuMTY1NTE4MDM4Ny42MA..#_ga=2.52394350.633075837.1655083587-195342684.1654569083"
                                >
                                    {t('hero_value7')}
                                    <LibraryAddOutlinedIcon
                                        sx={{
                                            verticalAlign: 'sub',
                                            paddingLeft: '6px',
                                        }}
                                    />
                                </a>
                            </div>

                            <span className="info-header">
                                {t('hero_value8')} :
                            </span>
                            <ul>
                                <li>{t('hero_value9')}</li>
                                <li>{t('hero_value10')}</li>
                                <li>{t('hero_value11')}</li>
                                <li>{t('hero_value12')}</li>
                            </ul>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div className="hero-img">
                            <div className="position-ab">
                                <img src={card} alt="card" />
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <Container maxWidth="md">
                            <Grid
                                container
                                columns={{ xs: 4, sm: 12, md: 12 }}
                                columnSpacing={{ xs: 2, sm: 2, md: 4 }}
                            >
                                <Grid item xs={12} sm={6} md={3}>
                                    <div className="hero-icon">
                                        <img src={time} alt="time" />
                                        <span>{t('hero_value3')}</span>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <div className="hero-icon">
                                        <img src={currency} alt="currency" />
                                        <span>{t('hero_value4')}</span>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <div className="hero-icon">
                                        <img src={verified} alt="verified" />
                                        <span>{t('hero_value5')}</span>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <div className="hero-icon">
                                        <img src={payment} alt="payment" />
                                        <span>{t('hero_value6')}</span>
                                    </div>
                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default Hero;
